import type { EntityPageState } from './types'

import { PublicFootballRequestError } from '~/lib/public-football-read'

export function toEntityPageState<T>(query: {
  data: T | undefined
  error: Error | null
  isPending: boolean
  isFetching: boolean
}): EntityPageState<T> {
  if (query.data) {
    return {
      status: 'success',
      data: query.data,
      isRefreshing: query.isFetching,
      refreshError: query.error !== null,
    }
  }
  if (query.error instanceof PublicFootballRequestError && query.error.status === 404)
    return { status: 'not-found' }
  if (query.error)
    return { status: 'error' }
  return { status: 'loading' }
}
